// used for loading product listing through ajax

bq.itemListingLoader = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.$listing  = '';
  this.totalLoaded = 0;
  this.totalPages = 1;
  this.currentPage = 1;
  this.perPage = 1;
  this.totalResults = 0;
  this.allItems = [];
  this.template = false;
  this.ajax = false;
  this.activeAjax = false;
  this.eventsCreated = false;
};

bq.itemListingLoader.DEFAULTS = {
  ajaxUrl: '',
  perPage: 12,
  startPage: 1,
  totalResults: false,
  listingHolder: '.item-listing',
  templateTarget: '.item-template',
  paginationContainer: false,
  ajaxParams: {},
  showPageStatus: false,
  pageTemplate: 'Page %page of %totalpages',
  pageContainer: '.page-status-container',
  showItemStatus: false,
  itemTemplate: bq.messages.global.viewing+' <strong>%firstItem - %lastItem</strong> of <strong>%totalitems</strong>',
  itemContainer: '.item-status-container',
  errorTemplate: '<div class="alert alert-warning">%error%</div>'

};

bq.itemListingLoader.prototype = {
  init: function() {
    bq.debug.log("Item Listing Loader : init()", this.$element);

    /*if(this.options.totalResults.length <= 0) { //if no total results found, just exit with error
      bq.debug.error("Item Listing Loader : required data-* missing", this);
      return;
    }*/

    this.$listing = $(this.options.listingHolder, this.$element);
    this.allItems = $(this.options.templateTarget, this.$listing);
    this.totalLoaded = this.allItems.length;
    this.perPage = parseInt(this.options.perPage);

    this.totalResults = this.options.totalResults;

    this.totalPages = Math.ceil(this.options.totalResults/this.perPage);
    this.currentPage = this.options.startPage;

    if(!this.template) { this.template = this.allItems[0]; }

    if(!this.totalResults || this.totalResults === 0) {
      this.totalResults = this.totalLoaded;
    }

    if(this.options.ajaxUrl.length > 1) {
      this.ajax = true;
    } else {
      //not using ajax, set pages to whats there
      this.totalPages = Math.ceil(this.totalLoaded/this.perPage);
    }

    if(this.totalPages === 0) { this.totalPages = 1; }

    this.throwEventPaginationUpdate();

    // //lets find out if we need to do anything
    // if(this.totalLoaded <= this.options.perPage && this.totalLoaded >= this.options.totalResults) {
    //   //if total loaded is less then or equel to per page and more or equel to the total results
    //   //then we dont need to do anything
    //   return;
    // }

    //this.allItems.addClass("fade hidden");

    // var itemsNeeded = this.options.perPage * this.currentPage;
    // var leftToLoad = this.totalResults - this.totalLoaded;
    // var start = itemsNeeded - this.options.perPage;
    // var end = itemsNeeded -1;

    // if(leftToLoad === 0 && end > (this.totalResults - 1)) {
    //   end = this.totalResults - 1;
    // }

    // this.showItems(start, end);

    // this.updatePage();

    this._initItems();
    this.updatePage();

    //catch events
    if(!this.eventsCreated) { //only run once
      this.$element.on('bq.pagination.ready', {thiz: this},  this.setPaging);
      this.$element.on('bq.pagination.changed', {thiz: this}, this.eventPageUpdate);
      this.$element.on('bq.itemlisting.update', {thiz: this}, this._catchEventUpdate);
      this.eventsCreated = true;
    }

  },

  getItems: function() {
    //lets figure out how many were expecting
    var leftToLoad = this.totalResults - this.totalLoaded;

    if(leftToLoad <= 0) {
      this._updateStatus();
      this.showItems();
      return;
    } //we dont need anymore
    //if(this.currentPage == 1) { start = 2; } else { start = this.currentPage; }

    if(this.activeAjax) {
      this._updateStatus();
      this.showItems();
      return;
    } //ajax is already running

    var params =  {};

    params = $.extend(params, this._getParams());

    this.throwEventLoadStart();

    var $this = this;

    $.post( this.options.ajaxUrl, params)
      .done(function( json ) {
        json = $.parseJSON(json);
        bq.debug.log("item listing : getItems : ajax done", json);

        //test for error
        if(json.error) {
          bq.debug.error("item listing : getItems : json error : " + json.errorMessage, this);
          $this._displayError(json.errorMessage);
        } else {
          //loop through and build items
          $this._buildItems(json.items);

          //lets recalculate
          $this.allItems = $($this.options.templateTarget, $this.$listing);
          $this.totalLoaded = $this.allItems.length;

          bq.debug.log("item listing : getItems : updating page");

          //update paging if needed
          if(json.results && json.results != $this.totalResults) {
            $this.totalResults = json.results;
            $this.totalPages = Math.ceil($this.totalResults/$this.perPage);
            if(isNaN($this.totalPages)) { $this.totalPages = 1; $this.options.currentPage = 1; $this.currentPage = 1; }
            $this.throwEventPaginationUpdate();
          }


          //update the page
          $this.updatePage();
          $this.throwEventDomUpdated();
        }
      })
      .fail(function( jqxhr, textStatus, error ) {
        var err = textStatus + ", " + error;
        bq.debug.error("item listing : getItems : ajax error : " + err, this);
        $this._displayError(err);

      })
      .always(function() {
        $this.throwEventLoadEnd();
      });

  },

  _buildItems: function(items) {
    var $this = this;
    //incase things were already half loaded, lets clear out the old ones
    this.$listing.find('[data-page="'+this.currentPage+'"]').remove();
    $.each(items, function(key, item) {
      bq.debug.log("item listing : getItems : in each", key, item);
      $this.buildItem(item);
    });
  },

  buildItem: function(item) {
    //let clone the template
    var newItem = $(this.template).clone(true); //were gunna copy all events

    //lets loop through each set of this item
    $.each(item, function(type, attributes) {
      var itemAttr = newItem.find('[data-bq-il-type="'+type+'"]');

      if(itemAttr.length === 0) {
        if(newItem.data('bqIlType') == type) {
          itemAttr = newItem;
        } else {
          return;
        }
      } //didnt find it, move on

      $.each(attributes, function(attr, value) {
        switch(attr) {
          case "text":
            itemAttr.text(value);
            break;
          case "html":
            itemAttr.html(value);
            break;
          default:
            itemAttr.attr(attr, value);
            break;
        }
      });

      if (attributes['class'] && attributes['class'] === 'single-ellipsis') {
        var elClass = 'single-ellipsis ' + type;

        $(itemAttr.children()[0]).wrap('<div class="' + elClass + '"></div>');
      }

    });

    newItem.addClass("fade hidden");

    //lets attach it to the $element
    this.$listing.append(newItem);

    this._setPageData(newItem, this.currentPage);

  },

  eventPageUpdate: function(e, oldEvent, oldPage, newPage) {
    var $this = e.data.thiz;

    if($this.currentPage == newPage) { return; } //already here

    $this.currentPage = newPage;
    $this.updatePage();

  },

  updatePage: function() {

    var pageItems = this.$listing.find('[data-page="'+this.currentPage+'"]');

    if(pageItems.length < this.perPage) {
      //so we have less then per page
      //we have to make sure its not the last page and were not supposed
      //to have less
      if(this.currentPage == this.totalPages && (this.totalResults % this.perPage == pageItems.length && pageItems.length != 0)) {
        //current page is the last one, but we have the right amount of items
        //we dont neeed to go get any more
      } else {
        bq.debug.log("item listing : updatePage : need more items", this.currentPage);
        this.getItems();
        return;
      }
    }
    this._updateStatus();
    this.showItems();

  },

  showItems: function() {
     //lets set the height (so page doesnt move)
    this.$element.height(this.$element.height());
    //lets hide whats there
    this.hideAllItems();
    //lets show new page
    var $this = this;

    this.$listing.find('[data-page="'+this.currentPage+'"]').each(function(){ $this.showItem(this); });

    //let set the height again
    this.$element.height('auto');
  },

  showItem: function(item) {
    if($(item)) {
      $(item).addClass('in').removeClass('hidden');
    }
  },

  hideAllItems: function() {
    this.allItems.removeClass('in').addClass('hidden');

  },

  _updatePagingVisibility: function(hide) {

    var target = this.$element;
    if(this.options.paginationContainer) { target = $(this.options.paginationContainer, this.$element);}
    if(!target) { target = this.$element; }

    var $pagination = target.find('[data-bq="pagination"]');

    if(hide) {
      $(this.options.itemContainer, this.$element).hide();
      $(this.options.pageContainer, this.$element).hide();
      $pagination.hide();
    } else {
      $(this.options.itemContainer, this.$element).show();
      $(this.options.pageContainer, this.$element).show();
      if(this.totalPages > 1) {
        $pagination.show();
      }
    }

    target.trigger('bq.pagination.update.visibility', [hide]);
  },

  _updateStatus: function() {

    var hideData = true;

    if(this.options.showPageStatus) {
      var html = this.options.pageTemplate;
      html = html.replace('%page', this.currentPage);
      html = html.replace('%totalpages', this.totalPages);
      if(this.totalPages >= 1) {
        $(this.options.pageContainer, this.$element).html(html);
        hideData = false;
      } else {
        $(this.options.pageContainer, this.$element).html('');
      }
    }

    if(this.options.showItemStatus) {
      var html2 = this.options.itemTemplate;
      var firstItem = this.currentPage * this.perPage - this.perPage + 1;

      var lastItem = this.currentPage * this.perPage;
      if(lastItem > this.totalResults) { lastItem = this.totalResults; }


      var _firstItem = Number(firstItem).toLocaleString('en');
      var _lastItem = Number(lastItem).toLocaleString('en');
      var _totalResults = Number(this.totalResults).toLocaleString('en');

      //FIX IE10 bug with toLocaleString - always returns `.00` or `,00` in the end despite of different options
      if (_firstItem.slice(-3) == '.00' || _firstItem.slice(-3) == ',00') {
        _firstItem = _firstItem.substring(0, _firstItem.length - 3);
      }
      if (_lastItem.slice(-3) == '.00' || _lastItem.slice(-3) == ',00') {
        _lastItem = _lastItem.substring(0, _lastItem.length - 3);
      }
      if (_totalResults.slice(-3) == '.00' || _totalResults.slice(-3) == ',00') {
        _totalResults = _totalResults.substring(0, _totalResults.length - 3);
      }
      
      html2 = html2.replace('%firstItem', _firstItem);
      html2 = html2.replace('%lastItem', _lastItem);
      html2 = html2.replace('%totalitems', _totalResults);

      if(this.totalResults >= 1) {
        $(this.options.itemContainer, this.$element).html(html2);
        hideData = false;
      } else {
        $(this.options.itemContainer, this.$element).html('');
      }
    }

    this._updatePagingVisibility(hideData);

  },

  _getParams: function() {

    var extra = {};

    this.options.ajaxParams = this.$element.data('ajaxParams'); //reload params incase they have changed

    if(typeof(this.options.ajaxParams) === "string") {
      try {
        this.options.ajaxParams = $.parseJSON(this.options.ajaxParams);
      } catch(ex) {
        bq.debug.error("Item listing : error parsing data-ajax-params", ex);
        this.options.ajaxParams = {}; //error parsing json, make blank
      }
    }

    if(this.$element.data('perPage')) {
      this.perPage = parseInt(this.$element.data('perPage'));
      this.options.perPage = this.perPage;
    }

    return $.extend({}, this.options.ajaxParams);
  },

  _initItems: function() {
    var $this = this;
    if(this.totalPages == 1) {
      $.each(this.allItems, function() {
        $this._setPageData(this, 1);
      });
    }

    for (var i = 1; i <= this.totalPages; i++) {
      var end = i*this.perPage;
      var start = end - (this.perPage - 1);
      if(isNaN(end) || isNaN(start)) { return; } //something went wrong ;/
      if(end > this.totalResults) { end = this.totalResults; } //end is larger then total results

      for(var a = start; a <= end; a++) {
        if(this.allItems[a-1]) {
          $this._setPageData(this.allItems[a-1], i);
        } else {
          return;
        }
      }
    }
  },

  _setPageData: function(el, page) {
    $(el).attr('data-page', page);
  },

  _displayError: function(msg) {
    $('[data-page="error"]', this.$element).remove();

    var error = $(this.options.errorTemplate.replace('%error%', msg)).attr({'data-page':'error'});
    this.$listing.append(error);
    this.currentPage = 'error';
    this.showItems();

  },


  setPaging: function(e) {
    bq.debug.log("item listing : event caught [bq.pagination.ready]");
    var $this = e.data.thiz;
    $this.throwEventPaginationUpdate();
  },

  _clearData: function() {
    if(this.activeAjax) { return; }
    this._updatePagingVisibility(true);

    $(this.options.templateTarget, this.$listing).remove();
    $('[data-page="error"]', this.$listing).remove();
    this.options.currentPage = 1;
    this.currentPage = 1;
    this.totalPages = 1;
    this.totalResults = 1;
    this.options.totalResults = 1;
    this.options.startPage = 1;
    this.init();
  },

  throwEventDomUpdated: function() {
    bq.debug.log("item DOM Updated listing : event thrown [bq.domUpdated]");
    this.$element.trigger('bq.domUpdated', this);
  },

  throwEventLoadStart: function() {
    this.activeAjax = true;
    bq.debug.log("item Load Start listing : event thrown [bq.itemListing.loadStart]");
    this.$element.trigger('bq.itemListing.loadStart', this);
  },

  throwEventLoadEnd: function() {
    this.activeAjax = false;
    bq.debug.log("item Load End listing : event thrown [bq.itemListing.loadEnd]");
    this.$element.trigger('bq.itemListing.loadEnd', this);
  },

  throwEventPaginationUpdate: function() {
    bq.debug.log("item Pagination Update listing : event thrown [bq.pagination.update]", this.totalPages, this.currentPage);

    var target = this.$element;
    if(this.options.paginationContainer) { target = $(this.options.paginationContainer, this.$element);}
    if(!target) { target = this.$element; }

    //throws trigger (e, totalPages, currentPage)
    target.trigger('bq.pagination.update', [this.totalPages, this.currentPage]);
  },

  _catchEventUpdate: function(e, options) {
    var $this = e.data.thiz;
    if(options) {

      if(options.clear) {
        //clearing all data and reseting
        $this._clearData();
      }
    }

  }

};

// ITEM LISTING LOADER PLUGIN DEFINITION
// =======================

var itemListingLoaderold = $.fn.itemListingLoader;

$.fn.itemListingLoader = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.itemListingLoader');
    var options = $.extend({}, bq.itemListingLoader.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.itemListingLoader', (data = new bq.itemListingLoader(this, options))); }
    data.init();
  });
};

$.fn.itemListingLoader.Constructor = bq.itemListingLoader;

// ITEM LISTING LOADER NO CONFLICT
// =================

$.fn.itemListingLoader.noConflict = function () {
  $.fn.itemListingLoader = itemListingLoaderold;
  return this;
};

// ITEM LISTING LOADER DATA-API
// ==============

bq.itemListingLoaderInit = function() {
  $('[data-bq="item-listing"]').each(function () {
    var el = $(this);
    if(el.data('bq.itemListingLoader')) { return; }
    el.itemListingLoader(el.data());
  });
};

bq.init.push(bq.itemListingLoaderInit);

